import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const SELECTOR_MENU = '.js-menu';
const SELECTOR_MENU_TOGGLE = '.js-menu-toggle';

const CLASS_TOGGLED = 'is-toggled';

/**
 * Open a menu.
 */
const open = (menu) => {
  disableBodyScroll(menu);
  menu.classList.add(CLASS_TOGGLED);
  document.body.setAttribute('data-menu', CLASS_TOGGLED);
  Array.from(
    document.querySelectorAll(SELECTOR_MENU_TOGGLE)
  ).forEach((element) => element.classList.add(CLASS_TOGGLED));
};

/**
 * Close a menu.
 */
const close = (menu) => {
  enableBodyScroll(menu);
  menu.classList.remove(CLASS_TOGGLED);
  document.body.removeAttribute('data-menu');
  Array.from(
    document.querySelectorAll(SELECTOR_MENU_TOGGLE)
  ).forEach((element) => element.classList.remove(CLASS_TOGGLED));
};

/**
 * Toggle a menu.
 */
const toggle = (menu) => {
  if (menu.classList.contains(CLASS_TOGGLED)) {
    close(menu);
  } else {
    open(menu);
  }
};

/**
 * Initialize menu functionality.
 */
const initialize = () => {
  const menu = document.querySelector(SELECTOR_MENU);
  if (!menu) {
    return;
  }
  const menuToggles = document.querySelectorAll(SELECTOR_MENU_TOGGLE);
  if (!menuToggles) {
    return;
  }
  Array.from(menuToggles).forEach((menuToggle) => {
    menuToggle.addEventListener('click', () => toggle(menu));
  });
};

initialize();
